module.exports = __webpack_public_path__ + "media/images/dividend/Disco-5843d5a653aa793fd69ad9294b9c26a2.gif";